import React from 'react';
import HeaderComponent from "../../components/header/header.component";
import Image2Paragraphs from "../../components/image-with-paragraphs/image-with-paragraphs.component";
import CTAComponent from "../../components/call-to-action/cta-footer.component";
import PATIENT_RESOURCES_GENERAL_DATA from "./patient-resources-general.data";

import ctaImage from '../../img/OCLA/CTA/CTA_OCLA.png';
import heroImage from '../../img/OCLA/patient-resources/patient-resources-hero.png';
import ButtonsDirectoryComponent from "../../components/buttons-directory/buttons-directory.component";
import Interior5050Component from "../../components/interior-50-50/interior-50-50.component";
import {Helmet} from "react-helmet";
import {hideMask} from "../../components/navigation/navigation.component";
import TextSectionButtonComponent from "../../components/text-section-button/text-section-button.component";
import SingleParagraph from "../../components/single-paragraph/single-paragraph";

class PatientResourcesGeneralPage extends React.Component {
    pageTitle = "Support for all your care needs";
    state = PATIENT_RESOURCES_GENERAL_DATA;
    render() {
        return (
            <div>
                <Helmet>
                    <meta name="description" content="Patient Resources" />
                    <title>{this.pageTitle} | Optum Care Lung and Allergy</title>
                </Helmet>
                <main className='page-body' onClick={hideMask}>
                    <HeaderComponent imageUrl={heroImage} title={this.pageTitle} />
                    <div className='row justify-content-around'>
                        {/*<div className="col-md-8 col-sm-12">*/}
                        {/*    <p className="text-centered">*/}
                        {/*       Finalizing development. Coming soon!*/}
                        {/*    </p>*/}
                        {/*</div>*/}
                    </div>
                    {/*<div className="image2paragraphs-container">*/}
                    {/*    {*/}
                    {/*        this.state.textSection1.map( ({ id, ...otherSectionProps }) => (*/}
                    {/*            <TextSectionButtonComponent key={id} {...otherSectionProps} />*/}
                    {/*        ))*/}
                    {/*    }*/}
                    {/*    {*/}
                    {/*        this.state.sections.map(({id, ...otherSectionProps}) => (*/}
                    {/*            <Image2Paragraphs key={id} {...otherSectionProps} />*/}
                    {/*        ))*/}
                    {/*    }*/}
                    {/*</div>*/}
                    {/*<div className="row justify-content-around no-padding">*/}
                    {/*    <div className="col-md-12 col-sm-12">*/}
                    {/*{*/}
                    {/*    this.state.textSection2.map( ({ id, ...otherSectionProps }) => (*/}
                    {/*        <TextSectionButtonComponent key={id} {...otherSectionProps} />*/}
                    {/*    ))*/}
                    {/*}*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<div className="row justify-content-around no-padding">*/}
                    {/*<div className="col-md-8 col-sm-12">*/}
                    {/*{*/}
                    {/*    this.state.interiorSection.map( ({ id, ...otherSectionProps }) => (*/}
                    {/*        <Interior5050Component key={id} {...otherSectionProps} />*/}
                    {/*    ))*/}
                    {/*}*/}
                    {/*</div>*/}
                    {/*</div>*/}

                    <div className="row justify-content-around no-padding">
                        <div className="col-md-12 col-sm-12">

                            {
                                this.state.section2.map(({id, ...otherSectionProps}) => (
                                    <Image2Paragraphs key={id} {...otherSectionProps} />
                                ))
                            }
                        </div>
                    </div>

                    <div className="row justify-content-around no-padding">
                        <div className="col-md-12 col-sm-12">

                            {
                                this.state.section3.map(({id, ...otherSectionProps}) => (
                                    <Image2Paragraphs key={id} {...otherSectionProps} />
                                ))
                            }
                        </div>
                    </div>

                    <div className="cta-container">
                            <CTAComponent
                                imageUrl={ctaImage}
                                htmlCopy={this.state.ctaInfo.htmlCopy}
                            />
                    </div>
                </main>
                
            </div>
        );
    }
}

export default PatientResourcesGeneralPage;